import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

export default function PrivateRoutes({children}) {
  let isAuth=useSelector((store)=>store.authReducer.isAuth)
  // console.log(isAuth,"auth")
 if(!isAuth){
  return <Navigate to={"/signin"}></Navigate>
 }else {
  return children
 }
}
